import React, { useState } from "react";

// DEV ONLY
const debug = false;
const defaultContact = !debug ? false : {
    "Type": "contact",
    "Owner": {
        "name": "SPA WORLD NO OWNER",
        "id": "45674000000518021",
        "email": "noowner@spaworld.com.au"
    },
    "Contact_Form_Message": null,
    "$field_states": null,
    "Lead_Creation_Notes": null,
    "Current_Contact_Owner": "noowner@spaworld.com.au",
    "SWNZ_SAUNA_EMAIL_MARKETING": [],
    "SPASA_Lead_Received": null,
    "$state": "save",
    "$process_flow": false,
    "Single_Line_15": "Yeah",
    "Currency": "AUD",
    "Pronto_CN_Spa_Store": null,
    "Billing_Country": "Australia",
    "JEX_Contact_Form_Message": null,
    "Single_Line_14": "Unit",
    "id": "45674000515102203",
    "Pronto_Phone": null,
    "$approval": {
        "delegate": false,
        "takeover": false,
        "approve": false,
        "reject": false,
        "resubmit": false
    },
    "First_Visited_URL": null,
    "Created_Time": "2025-04-29T11:46:01+12:00",
    "Product_Name": null,
    "Country_Website_New": [
        "AU"
    ],
    "JEX_Contact_Form_Enquiry_Type": null,
    "SO_Form_Clearance_item": null,
    "SWNZ_HEATING_EMAIL_MARKETING": [],
    "Preferred_Shipping_Option": null,
    "Customer_Type": null,
    "Convert_to_Affiliate": false,
    "Append_to_Person_Notes": null,
    "Pronto_Country": null,
    "Referring_Affiliate_ID": null,
    "Last_Visited_Time": null,
    "Created_By": {
        "name": "Stock Manager",
        "id": "45674000000510290",
        "email": "swau@keetrax.com"
    },
    "Imported_From": null,
    "Nearest_Store": null,
    "SWAU_Deal": null,
    "Number_Of_Chats": null,
    "Have_a_permit_specialist_call": false,
    "Related_Affiliate": null,
    "Referring_Affiliate_Email": null,
    "Billing_Address_City": "City",
    "Social_Selling_Contact": null,
    "$review_process": {
        "approve": false,
        "reject": false,
        "resubmit": false
    },
    "JEX_Preferred_Contact_Method": null,
    "Concierge_URL": "https://book.spaworld.com.au/#/3480000000578022",
    "Average_Time_Spent_Minutes": null,
    "Salutation": null,
    "Poolz_Lead_Received": null,
    "Pronto_Balance": null,
    "Full_Name": "Mike Martel",
    "Account_Name": null,
    "Billing_Street_2": "Unit",
    "leadchain0__Social_Lead_ID": null,
    "Email_Opt_Out": false,
    "Previous_Contact_Owner": null,
    "SWAU_SAUNA_MARKETING_CAMPAIGNS": [],
    "SO_Order_Confirmation_Number": null,
    "SO_Form_Order_Total": null,
    "MA_SWAU_CLEARANCE_MARKETING_CAMPAIGN": [],
    "Lead_Created_Time": null,
    "Thrive_Lead": false,
    "Mobile": "+61214567890",
    "Marketing_Opt_Out": false,
    "smsmagic4__LeadIdCPY": null,
    "Thrive_Invite_Sent": false,
    "$orchestration": false,
    "Product_Interest": null,
    "Layout": {
        "display_label": "Standard",
        "name": "Standard",
        "id": "45674000000000629"
    },
    "SWAU_HEATING_MARKETING_CAMPAIGN": [],
    "Additional_Phone_Extension": null,
    "Locked__s": false,
    "Lead_Source": null,
    "Consultant": "SPA WORLD NO OWNER",
    "Tag": [],
    "Company": null,
    "Email": "nathan100@hotmail.com",
    "$currency_symbol": "AU$",
    "Additional_Phone": null,
    "SPASA_Lead": false,
    "Visitor_Score": null,
    "Clearance_Item_Product_Type": null,
    "Concierge_Extension": "9043",
    "Country_Website": "AU",
    "Last_Activity_Time": "2025-05-14T13:21:14+12:00",
    "Expired_Contact": false,
    "JEX_Product_Interest": [],
    "Unsubscribed_Mode": null,
    "Billing_Postcode": "1234",
    "Exchange_Rate": 1,
    "Test": false,
    "JEX_Contact_Form_Type": null,
    "$locked_for_me": false,
    "Preferred_Contact_Method": null,
    "JEX_Best_Contact_Time": null,
    "$approved": true,
    "Reporting_To": null,
    "Contact_Form_Type": null,
    "JEX_Showroom": false,
    "Territory": null,
    "Days_Visited": null,
    "SWAU_SHADE_EMAIL_MARKETING": [],
    "$editable": true,
    "Poolz_Lead": false,
    "Form_Pick_List_Validator": null,
    "Billing_Address_Different_From_Delivery_Address": false,
    "Spouse": "Test",
    "Delivery_State": "TAS",
    "Date_Thrive_Invite_Sent": null,
    "Preferred_Showroom": "Alexandria",
    "SWAU_SPA_EMAIL_MARKETING": [],
    "$zia_owner_assignment": "owner_recommendation_unavailable",
    "Secondary_Email": null,
    "$is_duplicate": false,
    "Brand1": null,
    "Last_Contacted_Date": null,
    "Billing_Address_Street": "Delivery",
    "Manual_Entry": null,
    "Warehouse": null,
    "MA_SWNZ_CLEARANCE_MARKETING_CAMPAIGNS": [],
    "SMS_Opt_Out": null,
    "$layout_id": {
        "display_label": "Standard",
        "name": "Standard",
        "id": "45674000000000629"
    },
    "SWNZ_SHADE_EMAIL_MARKETING": [],
    "Active_Deal_Name": null,
    "First_Name": "Mike",
    "SO_Date_Signed": null,
    "Contact_Type": [],
    "Modified_By": {
        "name": "Stock Manager",
        "id": "45674000000510290",
        "email": "swau@keetrax.com"
    },
    "First_Store": null,
    "$review": null,
    "Phone": null,
    "JEX_First_touch_URL_test": null,
    "SWNZ_SPA_EMAIL_MARKETING": [],
    "Delivery_Postcode": "1234",
    "Notes": null,
    "Original_Contact_Owner": null,
    "Modified_Time": "2025-05-14T13:21:14+12:00",
    "How_Can_We_Help_You": null,
    "Is_Contact_Associated_to_an_Account": false,
    "Unsubscribed_Time": null,
    "Title": null,
    "Delivery_City": "City",
    "SWe_Mailchimp_Import_Tags": [],
    "Delivery_Country": "Australia",
    "Concierge_Override": false,
    "Extension": null,
    "SWe_MC_Audience_Engagement": [],
    "Thrive_Lead_Received": null,
    "First_Visited_Time": null,
    "Concierge": {
        "name": "Joan Sagun",
        "id": "45674000001361258"
    },
    "Spa_Model": null,
    "Billing_State_All": "TAS",
    "Last_Name": "Martel",
    "$in_merge": false,
    "Sales_Lead_From": "Social Selling",
    "Referrer": null,
    "Affiliate_Product_Interest": [],
    "SWNZ_Deal_Completion": null,
    "Pick_List_6": null,
    "$approval_state": "approved",
    "Pronto_CN_Spa_World": null
};

export const Context = React.createContext();
export default function StockManagerContextProvider({ children }) {
	const [currentCustomer, setCurrentCustomer] = useState(defaultContact);
	const [openCustomerForm, setOpenCustomerForm] = useState();

	return (
		<Context.Provider value={{ currentCustomer, setCurrentCustomer, openCustomerForm, setOpenCustomerForm }}>
			{children}
		</Context.Provider>
	);
};
